import React, { useEffect, useState } from "react";
import useAuth from "../../../hooks/useAuth";
import AllPostTable from "../../AllPost/AllPostTable";
// import swal from "sweetalert";


const MyPost = () => {
  const { user } = useAuth();
  const [allBookings, setAllBookings] = useState([]);

  useEffect(() => {
    fetch(`https://polar-tor-73503.herokuapp.com/post/`)
      .then((res) => res.json())
      .then((data) => {
        console.log(data.post);
        // setAllBookings(data);
        const datapost = data.post;
        const mybooking = datapost.filter((dt) => dt.email === user.email);
        console.log(mybooking);
        setAllBookings(mybooking);
      });
  }, [user.email]);


  // const {email,name,userphotoURL,status,title,department, _id} =allBookings
  return (
    <div>
      <h1 className="mt-3 mb-3 text-4xl font-bold text-center pt-3 text-gray-900">
        My Post List
      </h1>
      <div className="flex flex-col container mx-auto my-8">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3  text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Message
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3  text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Type
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3  text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Date
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3  text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Group
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3  text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Phone
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3  text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3  text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Edit
                    </th>


                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {allBookings?.map((allBooking) => (
                    <AllPostTable
                      allBooking={allBooking}
                      key={allBooking._id}
                    ></AllPostTable>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyPost;
